<template>
  <v-popover
      placement="bottom"
      offset="11"
      open-group="space-leave-popover"
      popoverClass="space-leave-popover">
    <BaseButton size="xs" theme="red-outline" class="group" @click="confirmation=true">
      <IconLeave class="text-icon group-hover:text-white mr-4"/>
      <span>{{ $t('leaveSpace') }}</span>
    </BaseButton>
    <template slot="popover">
      <div class="col-span-2">
        <div class="text-lg font-bold text-text">
          {{ $t('attention') }}
        </div>
        <p class="mb-5 text-text text-2sm mx-4" v-html="$t('attentionText')"></p>
      </div>

      <BaseButton size="sm" theme="red" @click="apply"
                  v-close-popover
                  :loading="submitted">
        {{ $t('apply') }}
      </BaseButton>
      <BaseButton size="sm" theme="white" v-close-popover @click="cancel">
        {{ $t('cancel') }}
      </BaseButton>
      <div class="col-span-2 grid grid-cols-2 cols-gap-6">
      </div>
    </template>
  </v-popover>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import BaseButton from "@/components/UI/BaseButton";
import IconLeave from "@/components/icons/IconLeave";

export default {
  name: "LeaveBtn",
  components: {IconLeave, BaseButton},
  data() {
    return {
      confirmation: false,
      submitted: false
    }
  },
  computed: {
    ...mapGetters('space', ['spacesList']),
  },
  methods: {
    ...mapActions('space', ['leaveSpace', 'getActiveSpaces']),
    ...mapActions('cabinet', ['forwardUserFromDeletedSpace']),
    ...mapActions('cabinet/user', ['setUserPrimarySpaceId']),
    async apply() {
      this.submitted = true;
      try {
        const res = await this.leaveSpace()
        await this.getActiveSpaces()
        if (res.body.success) {
          this.forwardUserFromDeletedSpace();
          this.$toasted.error('Вы успешно покинули пространство');
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.submitted = false;
      }
    },
    cancel() {
      this.submitted = false
      this.confirmation = false
    }
  },
  i18n: {
    messages: {
      en: {
        leaveSpace: 'Leave workspace',
        attention: 'Leave workspace',
        attentionText: 'You will not be able to return until the administrator invites you.',
        apply: 'Leave',
        cancel: 'Cancel'
      },
      ru: {
        leaveSpace: 'Покинуть пространство',
        attention: 'Покинуть пространство',
        attentionText: 'Вы не сможете вернуться, пока администратор не пригласит вас.',
        apply: 'Выйти',
        cancel: 'Отмена'
      }
    }
  }
}
</script>

<style lang="scss">
.tooltip.popover.space-leave-popover {
  &:before {
    position: fixed;
    content: '';
  }

  &:focus {
    @apply outline-none;
  }

  .popover-inner {
    @apply p-4 bg-block shadow-primaryBlock rounded;
    width: 300px;
    z-index: 2;

    > div {
      @apply grid grid-cols-2 col-gap-4 row-gap-4;
    }
  }

  &[x-placement^="top"] {
    .popover-arrow {
      border-width: .8rem .8rem 0 .8rem;
      bottom: -.8rem;
    }
  }

  &[x-placement^="bottom"] {
    .popover-arrow {
      top: -.8rem;
      border-width: 0 .8rem .8rem .8rem;
    }
  }

  .popover-arrow {
    @apply border-block;
    z-index: 1;
    filter: drop-shadow(0px 4px 8px rgba(86, 114, 155, 0.6));
  }
}
</style>